export enum ExperimentalTarget {
  None = 0,
  CareerAndBusiness = 1,
  KidsClasses = 2,
  LiveAbroad = 3,
  CultureTravelHobby = 4,
  Other = 5,
}

export const ExperimentalTargetLabel = new Map<number, string>([
  [ExperimentalTarget.CareerAndBusiness, 'Carreira e negócios'],
  [ExperimentalTarget.KidsClasses, 'Aulas para crianças'],
  [ExperimentalTarget.LiveAbroad, 'Morar no exterior'],
  [ExperimentalTarget.CultureTravelHobby, 'Cultura, viagens e hobby'],
  [ExperimentalTarget.Other, 'Outro'],
]);
